import React from "react";
import { Utils, CountryCodes, AppConfig } from "../../../../helpers";
import { connect } from "react-redux";
import { Bets } from "../../../";

import TeamName from "../TeamName";
import Timer from "../Timer";
import { useMediaQuery } from "react-responsive";
import { LazyLoadImage, trackWindowScroll } from 'react-lazy-load-image-component';
import moment from "moment";


const IsMiddleScreenAndMobile = ({ children }) => {
  const isMiddleScreenAndMobile = useMediaQuery({ maxWidth: 720 });
  return isMiddleScreenAndMobile ? children : null;
};
const IsDesktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 720 });
  return isDesktop ? children : null;
};
let imageElement = document.createElement("img");
class TopBetsDetails extends React.Component {
  state = {
    renderCheckImage: false,
  };
  componentDidMount() {
    this.setState({
      renderCheckImage: true,
    });
  }
  checkImage = (teamId) => {
    this.setState({
      [teamId]: true,
    });
  };
  onEventClick = (item) => {
    const { history, setEvent, loadAllBetTypes, feedName, match } = this.props;
    setEvent(item);
    history.push(
      `/${feedName}/${match.params.feed}/${match.params.sport}/${
        match.params.sportName
      }/event/${item.eventCategory.sportCategoryId}/${
        item.eventTournament.tournamentId
      }/${item.eventId}`
    );
    const request = {
      Data: {
        Feed: { FeedId: Number(match.params.feed) },
        Sport: { SportId: Number(match.params.sport) },
        EventId: Number(match.params.eventId),
      },
    };
    loadAllBetTypes(request);
  };

  // getCountryCode = (name) => {
  //   let result =
  //   this.props.countryFlags &&
  //   this.props.countryFlags.filter((element) => {
  //     return element.countryName.toLowerCase() == name.toLowerCase();
  //   });
  // if (result && result.length > 0) {
  //   return result[0].countryFlagImagesName;
  // }
  // };
  formatDate =(utcDate) =>{
    const date = moment.utc(utcDate);
    const today = moment().utc().startOf('day');
  
    // Check if the date matches today's date
    if (date.isSame(today, 'day')) {
      return 'Today, ';
    }
  
    // Calculate the date after one week
    const oneWeekLater = moment().startOf('day').add(7, 'days');
  
    // Check if the date is within the next week
    if (date.isSameOrBefore(oneWeekLater)) {
      return `${date.format('dddd')}, `;
    }
  
    // Return the date itself for dates after one week
    return ``;
  }
  
  render() {
    const { data, showBetTypes, showNumber } = this.props;
    return (
      <div className="event" onClick={() => this.onEventClick(data)}>
        {data && (
          <>
            <IsDesktop>
              <div
                id="top-bets-details-container"
                className="container"
                style={{ paddingTop: "8px", paddingBottom: "8px" }}
              >
                <div
                  className="row-1"
                  style={{ paddingRight: "15px", paddingLeft: "15px" }}
                >
                  <div>
                    <p
                      style={{
                        textAlign: "start",
                        opacity: "50%",
                        marginBottom: "0px",
                      }}
                    >
                      {this.formatDate(data.eventDateOfMatch)} {data.eventDateOfMatchFormated}
                    </p>
                  </div>

                  {data.feed.feedId == 5 && (
                    <div className="date">
                      <div>{`${data.eventStatus &&
                        data.eventStatus.eventStatusDisplayName}`}</div>
                      {data.eventScore && (
                        <Timer type="up" time={data.eventScore.eventTime} />
                      )}
                    </div>
                  )}
                  <div className="league">
                    <img
                      style={{
                        width: "25px",
                        height: "15px",
                        marginRight: "4px",
                      }}
                      src={
                        AppConfig.countryFlagImagesPath +
                        (data.eventCategory.categoryFlagCode
                          ? data.eventCategory.categoryFlagCode
                          : `eu`) +
                        `.webp`
                      }
                      alt="country-flag"
                    />
                    &nbsp;
                    <span>{data.eventCategory.categoryDisplayName}</span>
                    <span style={{ opacity: "50%" }}>
                      /{data.eventTournament.tournamentDisplayName}
                    </span>
                  </div>
                  <div>
                    <p
                      style={{
                        textAlign: "end",
                        opacity: "50%",
                        marginBottom: "0px",
                      }}
                    >{`ID: ${data.eventBetLineNo}`}</p>
                  </div>
                </div>

                <hr
                  style={{
                    border: "solid",
                    borderWidth: "0.25px",
                    opacity: "25%",
                  }}
                />
                <div className="row-2" style={{ paddingTop: "5px" }}>
                  <div className="col-1">
                    {!this.state[data.eventHomeTeamId] && (
                      <div className="row-1">
                        <img
                          className="center"
                          src={`${AppConfig.teamsIconPath}${
                            data.eventHomeTeamId
                          }_b.webp`}
                          alt="leagues-icon"
                          onError={() => this.checkImage(data.eventHomeTeamId)}
                          height={"34px"}
                          width={"34px"}
                        />
                      </div>
                    )}
                    {this.state[data.eventHomeTeamId] &&
                    data.eventHomeTeamName.split(" ").length >= 2 ? (
                      <div
                        style={
                          data.eventHomeTeamColor &&
                          data.eventHomeTeamColor != "ffffff"
                            ? { backgroundColor: `#${data.eventHomeTeamColor}` }
                            : { backgroundColor: "#AEB4BF" }
                        }
                        className="topbets-alternative-image"
                      >
                        {" "}
                        <span>{data.eventHomeTeamName.split(" ")[0][0]}</span>
                        <span>{data.eventHomeTeamName.split(" ")[1][0]}</span>
                      </div>
                    ) : this.state[data.eventHomeTeamId] &&
                      data.eventHomeTeamName.split(" ").length == 1 ? (
                      <div
                        style={
                          data.eventHomeTeamColor &&
                          data.eventHomeTeamColor != "ffffff"
                            ? { backgroundColor: `#${data.eventHomeTeamColor}` }
                            : { backgroundColor: "#AEB4BF" }
                        }
                        className="topbets-alternative-image"
                      >
                        {" "}
                        <span>{data.eventHomeTeamName.split(" ")[0][0]}</span>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="row-2">
                      <TeamName name={data.eventHomeTeamName} />
                    </div>
                  </div>

                  <div className="col-2" style={{ width: "35%" }}>
                    <div className="row-1">
                      <span className="vs">1</span>
                      <span className="vs">X</span>
                      <span className="vs">2</span>
                    </div>
                    <div className="row-2">
                      {showBetTypes && (
                        <Bets.EventOdd
                          eventEnabled={data.enableBet}
                          showFieldName
                          showDetails
                          oddId={"1_-1"}
                          eventId={data.key}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-2">
                    {" "}
                    {!this.state[data.eventAwayTeamId] && (
                      <div className="row-1">
                        {" "}
                        <img
                          className="center"
                          src={`${AppConfig.teamsIconPath}${
                            data.eventAwayTeamId
                          }_b.webp`}
                          alt="leagues-icon"
                          onError={() => this.checkImage(data.eventAwayTeamId)}
                          height={"34px"}
                          width={"34px"}
                        />
                      </div>
                    )}
                    {this.state[data.eventAwayTeamId] &&
                    data.eventAwayTeamName.split(" ").length >= 2 ? (
                      <div
                        style={
                          data.eventAwayTeamColor &&
                          data.eventAwayTeamColor != "ffffff"
                            ? { backgroundColor: `#${data.eventAwayTeamColor}` }
                            : { backgroundColor: "#AEB4BF" }
                        }
                        className="topbets-alternative-image"
                      >
                        {" "}
                        <span>{data.eventAwayTeamName.split(" ")[0][0]}</span>
                        <span>{data.eventAwayTeamName.split(" ")[1][0]}</span>
                      </div>
                    ) : this.state[data.eventAwayTeamId] &&
                      data.eventAwayTeamName.split(" ").length == 1 ? (
                      <div
                        style={
                          data.eventAwayTeamColor &&
                          data.eventAwayTeamColor != "ffffff"
                            ? { backgroundColor: `#${data.eventAwayTeamColor}` }
                            : { backgroundColor: "#AEB4BF" }
                        }
                        className="topbets-alternative-image"
                      >
                        {" "}
                        <span>{data.eventAwayTeamName.split(" ")[0][0]}</span>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="row-2">
                      <TeamName name={data.eventAwayTeamName} />
                    </div>{" "}
                  </div>
                </div>
              </div>
            </IsDesktop>

            <IsMiddleScreenAndMobile>
              <div id="mobile-top-bets-details-container" className="container">
                <div style={{ padding: "13px 0 0 0" }}>
                  <div>
                    <p className="top-bets-header-details">{`ID: ${
                      data.eventBetLineNo
                    }`}</p>
                  </div>
                  <div
                    className="league"
                    style={{ margin: "auto", width: "50%" }}
                  >
                    <p style={{ display: "inline" }}>
                      <img
                        style={{
                          width: "25px",
                          height: "15px",
                          marginRight: "4px",
                        }}
                        src={
                          AppConfig.countryFlagImagesPath +
                          (data.eventCategory.categoryFlagCode
                            ? data.eventCategory.categoryFlagCode
                            : `eu`) +
                          `.webp`
                        }
                        alt="country-flag"
                      />
                      &nbsp;
                      <span>{data.eventCategory.categoryDisplayName}</span>
                      <span style={{ opacity: "50%" }}>
                        /{data.eventTournament.tournamentDisplayName}
                      </span>
                    </p>
                  </div>

                  <div>
                    <p className="top-bets-header-details">
                    {this.formatDate(data.eventDateOfMatch)} {data.eventDateOfMatchFormated}
                    </p>
                    {/* {data.feed.feedId == 5 && (
                <div className="date">
                  <div>{`${data.eventStatus &&
                    data.eventStatus.eventStatusDisplayName}`}</div>
                  {data.eventScore && (
                    <Timer type="up" time={data.eventScore.eventTime} />
                  )}
                </div>
              )} */}
                  </div>
                </div>

                <hr
                  style={{
                    border: "solid",
                    borderWidth: "1px",
                    opacity: "0.1",
                  }}
                />
                <div className="top-bets-match-details">
                  <div className="top-bets-match-teams">
                    <TeamName name={data.eventHomeTeamName} />
                    <TeamName name={data.eventAwayTeamName} />
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-around" }}
                  >
                    <span className="vs">1</span>
                    <span className="vs">X</span>
                    <span className="vs">2</span>
                  </div>
                  <div style={{ width: "100%" }}>
                    <div className="row-2">
                      {showBetTypes && (
                        <Bets.EventOdd
                          eventEnabled={data.enableBet}
                          showFieldName
                          showDetails
                          oddId={"1_-1"}
                          eventId={data.key}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </IsMiddleScreenAndMobile>
          </>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    countryFlags: state.general.countryFlags,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(trackWindowScroll(TopBetsDetails));
